import { dataHooks } from '../../../../libs/dataHooks';

export const forYouCategoriesListDataHooks = dataHooks<{
  listItem: { slug: string };
}>('forYouCategoriesList');
